import { authorizedGetCall } from "./APIsService";

export const getDashboardStats = () => {
  return new Promise((resolve, reject) => {
    authorizedGetCall(`dashboard-stats`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
